module.exports = __webpack_public_path__ + "img/7.16e26df0.png";